/**
 * Calculates if the content is overflowing it element containing it
 * @param element - the DOM element which has a clientWidth and scrollWidth props
 * @returns {boolean} - True, if the content is overflowing, false otherwise.
 */
export default function isContentOverflowingElement(element) {
  if (element) {
    if (!('clientWidth' in element)) {
      throw 'Element does not have a clientWidth property';
    }

    if (!('scrollWidth' in element)) {
      throw 'Element does not have a scrollWidth property';
    }

    const clientWidth = element.clientWidth;
    const actualWidth = element.scrollWidth;

    if (!('clientHeight' in element)) {
      throw 'Element does not have a clientHeight property';
    }

    if (!('scrollHeight' in element)) {
      throw 'Element does not have a scrollHeight property';
    }

    const clientHeight = element.clientHeight;
    const actualHeight = element.scrollHeight;

    const isCollapsedByWidth = actualWidth > clientWidth;
    const isCollapsedByHeight = actualHeight > clientHeight;
    return isCollapsedByHeight || isCollapsedByWidth;
  }

  return false;
}
